export * from './account';
export * from './wallet';
export * from './pass';
export * from './bankCard';

export function loadOwn() {
  return {
    type: 'LOAD_OWN',
  };
}

export function loadOwnCompletion(error = null, loginCode = 0, own = null) {
  return {
    type: 'LOAD_OWN_COMPLETION',
    error,
    loginCode,
    own,
  };
}

export function setShareUid(shareUid = null) {
  return {
    type: 'SET_SHARE_UID',
    shareUid,
  };
}

export function setShareManagerUid(uid = null, shareManagerUid = null, ua = null) {
  return {
    type: 'SET_SHARE_MANAGER_UID',
    uid,
    shareManagerUid,
    ua,
  };
}
